import React, { useState } from "react";
import { toast } from "sonner";
import { Clock, Users, Phone } from "lucide-react";
import { patchSalaBooking, slotsFor } from "../../lib/salaApi";

// TheFork e-mails don't carry the time: these bookings wait here until staff taps the right slot.
export function PendingTimeList({ rows, services, onChanged }) {
  const slots = slotsFor(services);
  if (!rows.length) return null;
  return (
    <section className="rounded-3xl border-2 border-amber-300 bg-amber-50 p-3 sm:p-4 space-y-3" data-testid="sala-pending-time">
      <div className="flex items-center gap-2 text-amber-900">
        <Clock className="h-4 w-4" />
        <h2 className="font-bold text-sm">Orario da confermare · {rows.length}</h2>
        <span className="text-xs text-amber-800/80">Arrivate da TheFork: controlla l'ora sul Manager e toccala qui</span>
      </div>
      {rows.map((b) => <PendingRow key={b.id} b={b} slots={slots} services={services} onChanged={onChanged} />)}
    </section>
  );
}

function PendingRow({ b, slots, services, onChanged }) {
  const [svc, setSvc] = useState(Object.keys(services || {})[0] || "");
  const [busy, setBusy] = useState("");
  const pick = async (time) => {
    setBusy(time);
    try { await patchSalaBooking(b.id, { time }); toast.success(`${b.name} · ${time}`); onChanged(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Errore"); }
    finally { setBusy(""); }
  };
  return (
    <div className="rounded-2xl bg-white border border-amber-200 p-3" data-testid={`sala-pending-${b.id}`}>
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm">
        <span className="font-bold text-[#2b1410]">{b.name}</span>
        <span className="inline-flex items-center gap-1 text-[#7c5a4e]"><Users className="h-3.5 w-3.5" /> {b.party_size}p</span>
        {b.phone && <span className="inline-flex items-center gap-1 text-[#7c5a4e]"><Phone className="h-3.5 w-3.5" /> {b.phone}</span>}
        <span className="rounded-full border bg-[#e6f4ef] text-[#1b6b4a] border-[#1b6b4a]/30 px-2 py-0.5 text-[10px] font-semibold">TheFork</span>
        {b.notes && <span className="text-xs italic text-[#7c5a4e]">{b.notes}</span>}
      </div>
      <div className="mt-2 flex items-center gap-2">
        <div className="flex bg-[#faf3ee] rounded-full p-0.5">
          {Object.entries(services || {}).map(([k, s]) => <button key={k} onClick={() => setSvc(k)} className={`h-7 rounded-full px-3 text-xs font-bold ${svc === k ? "bg-[#4a1c17] text-white" : ""}`} data-testid={`sala-pending-svc-${b.id}-${k}`}>{s.label}</button>)}
        </div>
        <div className="flex gap-1.5 overflow-x-auto no-scrollbar">
          {slots.filter((s) => s.key === svc).map((s) => (
            <button key={s.time} onClick={() => pick(s.time)} disabled={!!busy} data-testid={`sala-pending-slot-${b.id}-${s.time}`}
              className="shrink-0 h-9 rounded-xl border border-[#e8dcc8] bg-white px-3 font-mono text-sm font-bold hover:bg-[#4a1c17] hover:text-white active:scale-95 transition-colors disabled:opacity-50">{s.time}</button>
          ))}
        </div>
      </div>
    </div>
  );
}
